import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Icon,
    IconButton,
    InputAdornment,
    TextField,
    Switch,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    MenuItem,
    ButtonGroup,
    InputLabel,
    Select,
    Checkbox,
    FormControlLabel
} from "@mui/material";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import AptaTable from "examples/AptaTable";
import MDBox from "components/MDBox";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Search, FileDownload } from "@mui/icons-material";
import { SERVER_URL } from "constants/constant";
import * as XLSX from 'xlsx';


export const Author = ({ name, email, idx }) => (
    <MDBox lineHeight={1} style={{ display: "flex" }}>
        {/* <Icon color="inherit" fontSize="large">account_circle</Icon> */}
        <MDBox ml={1}>
            <MDTypography display="block" variant="button" fontWeight="medium">{name}</MDTypography>
            <MDTypography variant="caption">{email}</MDTypography>
        </MDBox>
    </MDBox>
);

const options = [
    { value: "Vegetarian", label: "Vegetarian" },
    { value: "Non-Vegetarian", label: "Non-Vegetarian" },
    { value: "Jain_food", label: "Jain Food" }
]
function Users() {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [indianDelegates, setIndianDelegates] = useState([]);
    const [foreignDelegates, setForeignDelegates] = useState([])
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedUser, setSelectedUser] = useState(null);
    const [editDialogOpen, setEditDialogOpen] = useState(false)
    const handleEditOpen = (user) => {
        setSelectedUser(user);
        setEditDialogOpen(true);
    };

    const handleEditClose = () => {
        setEditDialogOpen(false);
        setSelectedUser(null);
    };

    const handleEditSubmit = async () => {
        try {
            await axios.put(`${SERVER_URL}/user/edit/${selectedUser._id}`, selectedUser);
            Swal.fire("Success!", "User details updated successfully!", "success");
            fetchUsers();
            handleEditClose();
        } catch (error) {
            Swal.fire("Error!", "Failed to update user details.", "error");
        }
    };



    useEffect(() => {
        fetchUsers();
    }, []);

    async function fetchUsers() {
        try {
            const response = await axios.get(`${SERVER_URL}/get-all-users`);
            if (response.status === 200) {
                const allUsers = response?.data?.data?.allUsers?.reverse()
                setUsers(allUsers);
                const indian = allUsers?.filter(user => user?.category !== "Foreign_Delegate");
                const foreign = allUsers?.filter(user => user?.category === "Foreign_Delegate");
                setIndianDelegates(indian);
                setForeignDelegates(foreign);
            } else {
                console.error("Unexpected response code:", response.status);
            }
        } catch (error) {
            console.error("Error fetching users:", error.response?.data || error.message);
        }
    }

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleDelete = async (userId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.delete(`${SERVER_URL}/delete-user?userId=${userId}`);
                    if (response.status === 200) {
                        Swal.fire("Deleted!", "The user has been deleted.", "success");
                        fetchUsers();
                    } else {
                        Swal.fire("Error!", "Something went wrong. Try again.", "error");
                    }
                } catch (error) {
                    Swal.fire("Error!", "Failed to delete user.", "error");
                    console.error("Delete error:", error);
                }
            }
        });
    };

    const handlePaymentToggle = async (userId, currentStatus) => {
        try {
            const newStatus = !currentStatus ? "paid" : "unpaid"; // Toggle status
            const response = await axios.put(`${SERVER_URL}/user/update-payment-status/${userId}`, { paymentStatus: newStatus });

            if (response.status === 200) {
                Swal.fire("Success!", "Payment status updated.", "success");
                fetchUsers();
            } else {
                Swal.fire("Error!", "Failed to update payment status.", "error");
            }
        } catch (error) {
            Swal.fire("Error!", "Could not update payment status.", "error");
            console.error("Payment update error:", error);
        }
    };

    useEffect(() => {
        if (searchQuery === "") {
            const indian = users?.filter(user => user?.category !== "Foreign_Delegate");
            const foreign = users?.filter(user => user?.category === "Foreign_Delegate");
            setIndianDelegates(indian);
            setForeignDelegates(foreign);
        } else {
            const filteredUsers1 = users?.filter(user => user?.category !== "Foreign_Delegate")?.filter((user) =>
                (user.firstName + " " + user.lastName).toLowerCase().includes(searchQuery.toLowerCase()) ||
                user.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
                user.phoneNumber.toLowerCase().includes(searchQuery.toLowerCase())
            );
            const filteredUsers2 = users?.filter(user => user?.category === "Foreign_Delegate")?.filter((user) =>
                (user.firstName + " " + user.lastName).toLowerCase().includes(searchQuery.toLowerCase()) ||
                user.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
                user.phoneNumber.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setIndianDelegates(filteredUsers1)
            setForeignDelegates(filteredUsers2)
        }
    }, [searchQuery])
    const handleGenerate = async (id) => {
        await axios.get(`https://api.iria2026.com/api/iria/user/doc-email?userId=${id}`).then(res => {
            if (res.data) {
                Swal.fire("Success!", "The pdfs has been generated!");
                fetchUsers();
            }
        }).catch(err => {
            Swal.fire("Error!", err?.response?.data);
        })
    }

    const exportToExcel = (users, fileName) => {
        const filteredUsersForExcel = users?.map(({
            salutation,
            firstName,
            lastName,
            registrationCategory,
            userId,
            email,
            phoneNumber,
            city,
            state,
            paymentStatus,
            createdAt,
            is_speaker
        }) => ({
            Salutation: salutation || '',
            "First Name": firstName || '',
            "Last Name": lastName || '',
            "Registration Category": registrationCategory?.regiCategoryName || '',
            "Registration Date": createdAt?.slice(0, 10) || "",
            "Membership Number": userId || '',
            Email: email || '',
            Phone: phoneNumber || '',
            City: city || '',
            State: state || "",
            Status: paymentStatus || "",
            Role: is_speaker ? "Delegate + Speaker" : "Delegate"
        }));


        const worksheet = XLSX.utils.json_to_sheet(filteredUsersForExcel);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

        XLSX.writeFile(workbook, `${fileName}.xlsx`);
    };


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <SearchInput searchQuery={searchQuery} handleSearchChange={handleSearchChange} />
            {/* <Box display={'flex'} mb={3} justifyContent={'end'}>
                <Button style={{ color: 'white', backgroundColor: '#2ecc71' }}
                    onClick={exportToExcel}
                    variant='contained' >Download Excel</Button>
            </Box> */}
            <Box display={'flex'} mb={3} justifyContent={'end'}>
                <Button style={{ color: 'white', backgroundColor: '#2ecc71' }}
                    onClick={() => exportToExcel(indianDelegates, "Indian_Delegates")}
                    variant='contained' >Download Indian Excel</Button>
                <Button style={{ color: 'white', backgroundColor: '#3498db', marginLeft: 10 }}
                    onClick={() => exportToExcel(foreignDelegates, "Foreign_Delegates")}
                    variant='contained' >Download Foreign Excel</Button>
            </Box>
            <AptaTable
                title={"Indian Delegates"}

                columns={["Name", "Category", "Registration ID", 'Registration Date', "Phone", 'My Members', "Status", "Payment Status", "Generate", "View", 'Action']}
                rows={indianDelegates?.map((user, idx) => ({
                    Name: <Author name={`${user.firstName}`} email={user.email} idx={idx} />,
                    Category: user?.registrationCategory?.regiCategoryName
                    ,
                    "Registration ID": user.userId,
                    'Registration Date': user?.createdAt?.slice(0, 10) || '--',
                    Phone: <MDTypography variant="caption">{user.phoneNumber}</MDTypography>,
                    "Status":
                        <MDTypography variant="caption" fontWeight="bold" color={user.paymentStatus === "paid" ? "success" : "error"}>
                            {user?.paymentStatus}
                        </MDTypography>,
                    "Payment Status": (
                        <Switch
                            checked={user.paymentStatus === "paid"}
                            onChange={() => handlePaymentToggle(user._id, user.paymentStatus === "paid")}
                            color="success"
                        />
                    ),
                    "Generate":

                        <IconButton color="info" onClick={() => handleGenerate(user?._id)}>
                            <FileDownload />
                        </IconButton>,
                    View: (
                        <Button
                            variant="contained"
                            onClick={() => navigate(`/user-dashboard/${user._id}`, { state: { user } })}
                            style={{ color: "white" }}
                        >
                            <Icon>visibility</Icon>
                        </Button>
                    ),
                    "Action":
                        (
                            <ButtonGroup size='small'>
                                <Button color='info' style={{ color: '#2196f3' }} onClick={() => handleEditOpen(user)}>
                                    <Icon>edit</Icon>
                                </Button>
                                <Button style={{ color: 'red' }} color='error' onClick={() => handleDelete(user._id)}>
                                    <Icon>delete</Icon>
                                </Button>
                            </ButtonGroup>
                        )
                    , "My Members": user?.additionalPeople?.length
                }))}

            />
            <AptaTable
                title={"Foreign Delegates"}
                columns={["Name", "Category", "Registration ID", 'Registration Date', "Phone", 'My Members', "Status", "Payment Status", "Generate", "View", 'Action']}
                rows={foreignDelegates?.map((user, idx) => ({
                    Name: <Author name={`${user.firstName}`} email={user.email} idx={idx} />,
                    Category: <MDTypography variant="caption">{user?.registrationCategory?.regiCategoryName}</MDTypography>,
                    "Registration ID": <MDTypography variant="caption">{user.userId}</MDTypography>,
                    'Registration Date': user?.createdAt?.slice(0, 10) || '--',
                    Phone: <MDTypography variant="caption">{user.phoneNumber}</MDTypography>,
                    "Status":
                        <MDTypography variant="caption" fontWeight="bold" color={user.paymentStatus === "paid" ? "success" : "error"}>
                            {user?.paymentStatus}
                        </MDTypography>,
                    "Payment Status": (
                        <Switch
                            checked={user.paymentStatus === "paid"}
                            onChange={() => handlePaymentToggle(user._id, user.paymentStatus === "paid")}
                            color="success"
                        />
                    ),
                    "Generate":

                        <IconButton color="info" onClick={() => handleGenerate(user?._id)}>
                            <FileDownload />
                        </IconButton>,
                    View: (
                        <Button
                            variant="contained"
                            onClick={() => navigate(`/user-dashboard/${user._id}`, { state: { user } })}
                            style={{ color: "white" }}
                        >
                            <Icon>visibility</Icon>
                        </Button>
                    ),
                    "Action":
                        (
                            <ButtonGroup size='small'>
                                <Button color='info' style={{ color: '#2196f3' }} onClick={() => handleEditOpen(user)}>
                                    <Icon>edit</Icon>
                                </Button>
                                <Button style={{ color: 'red' }} color='error' onClick={() => handleDelete(user._id)}>
                                    <Icon>delete</Icon>
                                </Button>
                            </ButtonGroup>
                        )
                    , "My Members": user?.additionalPeople?.length
                }))}

            />
            {
                selectedUser && (
                    <Dialog open={editDialogOpen} onClose={handleEditClose}>
                        <DialogTitle>Edit User</DialogTitle>
                        <DialogContent>
                            <TextField label="Email" fullWidth margin="dense" value={selectedUser.email} onChange={(e) => setSelectedUser({ ...selectedUser, email: e.target.value })} />
                            <TextField label="Phone" fullWidth margin="dense" value={selectedUser.phoneNumber} onChange={(e) => setSelectedUser({ ...selectedUser, phoneNumber: e.target.value })} />
                            <TextField label="Institute" fullWidth margin="dense" value={selectedUser.institute} onChange={(e) => setSelectedUser({ ...selectedUser, institute: e.target.value })} />


                            <TextField label="Address" fullWidth margin="dense" value={selectedUser.address} onChange={(e) => setSelectedUser({ ...selectedUser, address: e.target.value })} />
                            <TextField label="City" fullWidth margin="dense" value={selectedUser.city} onChange={(e) => setSelectedUser({ ...selectedUser, city: e.target.value })} />
                            <TextField label="State" fullWidth margin="dense" value={selectedUser.state} onChange={(e) => setSelectedUser({ ...selectedUser, state: e.target.value })} />
                            <TextField label="Pincode" fullWidth margin="dense" value={selectedUser.pincode} onChange={(e) => setSelectedUser({ ...selectedUser, pincode: e.target.value })} />
                            <Box>
                                <InputLabel sx={{ paddingBottom: 1, marginTop: 2 }}>Food Preference</InputLabel>
                                <Select
                                    value={selectedUser.foodCategory} name="parentCategory"
                                    onChange={(e) => setSelectedUser({ ...selectedUser, foodCategory: e.target.value })} placeholder="Select a category"
                                    fullWidth
                                    style={{ height: 40 }}
                                >
                                    <MenuItem value="Select Food Preference" disabled >
                                        Select Food Preference
                                    </MenuItem>
                                    {options.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Box>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={Boolean(selectedUser.is_speaker)}
                                        onChange={(e) =>
                                            setSelectedUser({
                                                ...selectedUser,
                                                is_speaker: e.target.checked,
                                            })
                                        }
                                    />
                                }
                                label="Speaker"
                            />

                        </DialogContent>
                        <DialogActions>

                            <Button onClick={handleEditClose}>Cancel</Button>
                            <Button onClick={handleEditSubmit} color="primary">Save</Button>
                        </DialogActions>
                    </Dialog>
                )
            }
        </DashboardLayout>
    );
}

export default Users;

// SearchInput Component
export const SearchInput = ({ searchQuery, handleSearchChange }) => (
    <Box display="flex" justifyContent="center" mb={3} width="100%">
        <TextField
            variant="outlined"
            fullWidth
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Search by name, phone, email..."
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <IconButton>
                            <Search />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    </Box>
);


